<mat-sidenav-container>
  <mat-sidenav class="fixed-filter-width" #sidenavFilter mode="side" position="start">
    @if (isSearching) {
      <button (click)="closeMenu()"
        class="btn button-close-filter">
        <svg class="bi bi-x" fill="currentColor" height="25" viewBox="0 0 16 16" width="25"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
        <span>{{ 'CLOSE' | translate }}</span>
      </button>
    }
    <app-filter-menu (closeMenu)="closeMenu()"></app-filter-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <div [class.pr-0]="isSearching"
      class="container-fluid bg-white h-100 pl-0">
      <div [hidden]="isSearching" class="row h-100">
        <ng-content></ng-content>
      </div>
      @if (isSearching) {
        <div class="h-100">
          <app-search
            [startLoading]="startLoadingSearch"
          ></app-search>
        </div>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
